/*!
 * Copyright © 2021. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getBalloon } from '../../../core/store/selectors';
import { IReplayBalloonVideoDetails } from '../../../replay/models';
import { IReplayBalloon } from '../../../replay/models/replay-balloon.interface';

@Component({
  selector: 'fm-video-event-details',
  templateUrl: './video-event-details.component.html',
  styleUrls: ['./video-event-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoEventDetailsComponent implements OnInit {
  videoDetails$: Observable<IReplayBalloonVideoDetails>;

  constructor(
    private readonly _store: Store,
    private readonly _dialogRef: MatLegacyDialogRef<VideoEventDetailsComponent>
  ) {}

  public ngOnInit(): void {
    this.videoDetails$ = this._store.pipe(
      select(getBalloon),
      map(balloon => (balloon as IReplayBalloon)?.videoDetails)
    );
  }

  public close(): void {
    this._dialogRef.close();
  }
}
